const HIDDEN = 0;
const ACTIVE = 1;
const DONE = 2;

export default {
    HIDDEN,
    ACTIVE,
    DONE,
};